import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { generalInfoQuery, scenarioLevelsQuery, scenarioLevelsViewQuery } from './api';
import Game from './index';
import ApcLevel from './apcLevel';

export default function ThePrinciplesRouter() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);

  const { getCurrentThePrinciplesGameId } = useAuth();
  const gameId = getCurrentThePrinciplesGameId();

  const { data: generalInfo, isLoading: generalInfoLoading } = useQuery(generalInfoQuery());
  const games = generalInfo?.games;

  const game = games?.find(g => g.game_type.includes('The Principles') && g.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  const { data: answerData, isLoading: answerDataLoading } = useQuery({
    ...scenarioLevelsViewQuery(scenarioId),
    enabled: !!scenarioId,
  });

  if (generalInfoLoading || !scenarioId || levelsLoading || answerDataLoading) {
    return null;
  }

  const currentLevel = scenarioLevels?.find(level => level.level === levelNumber);
  const isApcLevel = currentLevel?.design?.includes('4');

  if (isApcLevel) {
    return <ApcLevel key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} answerData={answerData} />;
  }

  return <Game key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} scenarioId={scenarioId} answerData={answerData} />;
}
